/* ============================================================
   D.A.D Product page JS
   Owner: PRODUCT BUILDER scope
   Loaded only on product templates.
   ============================================================ */
window.DAD = window.DAD || {};
window.DAD.product = window.DAD.product || {};

(function () {
  "use strict";

  function initGallery(section) {
    const gallery = section.querySelector("[data-product-gallery]");
    if (!gallery) return;
    const slides = Array.from(gallery.querySelectorAll("[data-gallery-slide]"));
    const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));
    const prev = gallery.querySelector("[data-gallery-prev]");
    const next = gallery.querySelector("[data-gallery-next]");
    const zoom = gallery.querySelector("[data-gallery-zoom]");
    let current = 0;

    function goTo(index) {
      if (slides.length === 0) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle("is-active", i === current));
      thumbs.forEach((thumb, i) => {
        const active = i === current;
        thumb.classList.toggle("is-active", active);
        thumb.setAttribute("aria-selected", active ? "true" : "false");
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => goTo(parseInt(thumb.dataset.index, 10)));
    });
    if (prev) prev.addEventListener("click", () => goTo(current - 1));
    if (next) next.addEventListener("click", () => goTo(current + 1));

    if (zoom) {
      zoom.addEventListener("click", () => {
        gallery.classList.toggle("product-gallery--zoomed");
      });
      gallery.addEventListener("click", (e) => {
        if (gallery.classList.contains("product-gallery--zoomed") && e.target.tagName === "IMG") {
          gallery.classList.remove("product-gallery--zoomed");
        }
      });
    }

    document.addEventListener("keydown", (e) => {
      if (!slides.length) return;
      if (e.key === "Escape") gallery.classList.remove("product-gallery--zoomed");
    });
  }

  function initQuantity(section) {
    const wrapper = section.querySelector("[data-quantity]");
    if (!wrapper) return;
    const input = wrapper.querySelector("[data-quantity-input]");
    const dec = wrapper.querySelector("[data-quantity-decrease]");
    const inc = wrapper.querySelector("[data-quantity-increase]");
    if (!input) return;

    function setQty(v) {
      const min = parseInt(input.min || "1", 10);
      input.value = Math.max(min, v);
    }
    if (dec) dec.addEventListener("click", () => setQty(parseInt(input.value, 10) - 1));
    if (inc) inc.addEventListener("click", () => setQty(parseInt(input.value, 10) + 1));
    input.addEventListener("change", () => setQty(parseInt(input.value, 10) || 1));
  }

  function initVariantPicker(section) {
    const picker = section.querySelector("[data-variant-picker]");
    const jsonScript = section.querySelector("[data-product-json]");
    const variantInput = section.querySelector("[data-variant-id-input]");
    const stickyVariant = document.querySelector("[data-sticky-variant]");
    const submitBtn = section.querySelector("[data-add-to-cart]");
    const submitLabel = section.querySelector("[data-add-to-cart-label]");
    const priceNow = section.querySelector(".product-info__price-now");
    if (!picker || !jsonScript) return;

    let data;
    try { data = JSON.parse(jsonScript.textContent); } catch (e) { return; }
    if (!data || !data.variants) return;

    const fieldsets = Array.from(picker.querySelectorAll(".product-form__option"));

    function selectedOptions() {
      return fieldsets.map((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findMatchingVariant() {
      const sel = selectedOptions();
      return data.variants.find((v) => {
        return v.options.every((opt, i) => opt === sel[i]);
      });
    }

    function updateSelectedLabel(fieldset) {
      const labelSpan = fieldset.querySelector("[data-option-selected]");
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (labelSpan && checked) labelSpan.textContent = checked.value;
    }

    function formatMoney(cents) {
      const v = (cents / 100).toFixed(2);
      return v + " $";
    }

    function applyVariant(variant) {
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; }
        if (submitLabel) submitLabel.textContent = "Indisponible";
        const sb = section?.querySelector(".product-form__stock");
        const bw = section?.querySelector("[data-bis-wrapper]");
        const bn = section?.querySelector("[data-buy-now]");
        if (sb) sb.style.display = "none";
        if (bw) bw.style.display = "";
        if (bn) bn.style.display = "none";
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (stickyVariant) stickyVariant.value = variant.id;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      // Shopify Collective syncs inventory_policy from the supplier as "continue",
      // overriding any "deny" we set via API. So we check inventory_quantity
      // directly to detect true out-of-stock regardless of policy.
      const isOOS = variant.inventory_management === "shopify" && typeof variant.inventory_quantity === "number" && variant.inventory_quantity <= 0;
      const effectivelyAvailable = variant.available && !isOOS;

      if (submitBtn) submitBtn.disabled = !effectivelyAvailable;
      if (submitLabel) submitLabel.textContent = effectivelyAvailable ? "Ajouter au panier" : "Épuisé";

      // Update sticky bar button to match variant availability
      const stickyBtn = document.querySelector(".product-sticky__btn");
      if (stickyBtn) {
        stickyBtn.disabled = !effectivelyAvailable;
        stickyBtn.textContent = effectivelyAvailable ? (stickyBtn.dataset.addLabel || "Ajouter") : "Épuisé";
      }

      // Toggle stock badge / back-in-stock widget / buy-now on variant change
      const stockBadge = section?.querySelector(".product-form__stock");
      const bisWidget = section?.querySelector("[data-bis-wrapper]");
      const buyNowBtn = section?.querySelector("[data-buy-now]");
      if (stockBadge) stockBadge.style.display = effectivelyAvailable ? "" : "none";
      if (bisWidget) bisWidget.style.display = effectivelyAvailable ? "none" : "";
      if (buyNowBtn) buyNowBtn.style.display = effectivelyAvailable ? "" : "none";

      // Update URL with variant id for shareability
      try {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      } catch (e) { /* ignore */ }
    }

    picker.addEventListener("change", (e) => {
      if (e.target.matches('input[type="radio"]')) {
        const fs = e.target.closest(".product-form__option");
        if (fs) updateSelectedLabel(fs);
        applyVariant(findMatchingVariant());
      }
    });
  }

  function initStickyBar(section) {
    const bar = document.querySelector("[data-product-sticky]");
    const ctaForm = section.querySelector(".product-form__actions");
    if (!bar || !ctaForm) return;
    document.body.classList.add("has-sticky-product");
    const footer = document.querySelector(".site-footer");

    let ctaPassed = false;   // l'utilisateur a dépassé le bouton principal
    let footerShown = false; // le footer est visible -> on cache la barre (sinon elle couvre le footer)
    function update() {
      const show = ctaPassed && !footerShown;
      bar.classList.toggle("is-visible", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    }

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        ctaPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      update();
    }, { threshold: 0, rootMargin: "-80px 0px 0px 0px" }).observe(ctaForm);

    if (footer) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => { footerShown = entry.isIntersecting; });
        update();
      }, { threshold: 0 }).observe(footer);
    }
  }

  function init() {
    const sections = document.querySelectorAll("[data-product-section]");
    sections.forEach((section) => {
      initGallery(section);
      initQuantity(section);
      initVariantPicker(section);
      initStickyBar(section);
    });

    initMobileMenu();
    initReviewReveal();
    initCart();
    initCartDrawer();
    initAddToCart();
    initSearch();
    initPredictiveSearch();
    initBundles();
    // initBackInStock(); // disabled — will re-enable with Klaviyo
  }

  /* ============================================================
     TÉMOIGNAGES VIDÉO — révélation au scroll (stagger), opt-in
     ============================================================ */
  function initReviewReveal() {
    const grid = document.querySelector(".product-review__grid");
    if (!grid) return;
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    // Sans IntersectionObserver ou si l'utilisateur réduit les animations :
    // on ne touche à rien -> les cartes restent visibles (jamais cachées).
    if (reduce || !("IntersectionObserver" in window)) return;
    const cards = Array.prototype.slice.call(grid.querySelectorAll(".product-review__frame"));
    if (!cards.length) return;
    grid.classList.add("js-reveal"); // à partir d'ici, cartes masquées jusqu'au scroll
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        const card = e.target;
        const i = cards.indexOf(card);
        card.style.transitionDelay = (i % 3) * 0.12 + "s";
        card.classList.add("is-in");
        setTimeout(function () { card.style.transitionDelay = "0s"; }, 800 + (i % 3) * 120);
        io.unobserve(card);
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -6% 0px" });
    cards.forEach(function (c) { io.observe(c); });
  }

  /* ============================================================
     MENU MOBILE (header global — TOUTES les pages)
     Avant : vivait dans dad-homepage.js (chargé seulement sur l'accueil),
     donc le burger ne marchait pas sur les collections/produits/contact.
     ============================================================ */
  function initMobileMenu() {
    const toggle = document.querySelector("[data-mobile-toggle]");
    const menu = document.querySelector("[data-mobile-menu]");
    if (!toggle || !menu) return;
    if (toggle.dataset.bound) return; // jamais de double-binding
    toggle.dataset.bound = "1";

    function openMenu() {
      const header = document.querySelector("[data-site-header]");
      if (header) menu.style.top = header.getBoundingClientRect().bottom + "px";
      menu.removeAttribute("hidden");
      toggle.setAttribute("aria-expanded", "true");
      toggle.classList.add("is-open");
      document.body.classList.add("mobile-menu-open");
    }
    function closeMenu() {
      menu.setAttribute("hidden", "");
      toggle.setAttribute("aria-expanded", "false");
      toggle.classList.remove("is-open");
      document.body.classList.remove("mobile-menu-open");
    }
    toggle.addEventListener("click", () => {
      if (menu.hasAttribute("hidden")) openMenu(); else closeMenu();
    });
    menu.querySelectorAll("a").forEach((a) => a.addEventListener("click", closeMenu));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !menu.hasAttribute("hidden")) closeMenu();
    });
  }

  /* ============================================================
     CART page
     ============================================================ */
  function formatMoneyCents(cents) {
    const v = (cents / 100).toFixed(2);
    return v + " $";
  }

  function initCart() {
    const cartSection = document.querySelector("[data-cart-section]");
    if (!cartSection) return;
    const form = cartSection.querySelector("[data-cart-form]");
    if (!form) return;

    cartSection.querySelectorAll("[data-cart-qty]").forEach((wrap) => {
      const input = wrap.querySelector("[data-cart-qty-input]");
      const dec = wrap.querySelector("[data-cart-qty-decrease]");
      const inc = wrap.querySelector("[data-cart-qty-increase]");
      if (!input) return;

      function setQty(v) {
        const val = Math.max(0, isNaN(v) ? 1 : v);
        input.value = val;
        scheduleSubmit();
      }
      if (dec) dec.addEventListener("click", () => setQty(parseInt(input.value, 10) - 1));
      if (inc) inc.addEventListener("click", () => setQty(parseInt(input.value, 10) + 1));
      let t;
      input.addEventListener("change", () => {
        clearTimeout(t);
        t = setTimeout(scheduleSubmit, 200);
      });
    });

    let pendingSubmit;
    function scheduleSubmit() {
      clearTimeout(pendingSubmit);
      pendingSubmit = setTimeout(() => {
        // Use Shopify standard /cart update via form submit
        form.submit();
      }, 600);
    }

    cartSection.querySelectorAll("[data-cart-remove]").forEach((link) => {
      link.addEventListener("click", (e) => {
        // Allow native nav, but show subtle visual feedback
        const item = link.closest("[data-cart-item]");
        if (item) item.style.opacity = "0.5";
      });
    });
  }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  function initCartDrawer() {
    const drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    const toggles = document.querySelectorAll("[data-cart-toggle]");

    function open() {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      // Verrou de scroll par CLASSE (comme le menu + la recherche) pour ne pas
      // se battre avec leur overflow:hidden via un style inline.
      document.body.classList.add("cart-open");
      loadCartRecommendations();
    }
    function close() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("cart-open");
    }

    // Délégation : survit au re-render du contenu du tiroir (close + backdrop)
    drawer.addEventListener("click", (e) => {
      if (e.target.closest("[data-cart-drawer-close]") || e.target.matches("[data-cart-drawer-backdrop]")) {
        close();
        return;
      }

      // ── Boutons +/− de quantité (dans le tiroir) ──
      const inc = e.target.closest("[data-cart-qty-increase]");
      const dec = e.target.closest("[data-cart-qty-decrease]");
      if (inc || dec) {
        e.preventDefault();
        const item = (inc || dec).closest("[data-cart-item]");
        if (!item) return;
        const input = item.querySelector("[data-cart-qty-input]");
        let q = parseInt(input ? input.value : "1", 10);
        if (isNaN(q)) q = 1;
        q = inc ? q + 1 : q - 1;
        if (q < 0) q = 0;
        if (input) input.value = q;
        changeLine(item, q);
        return;
      }

      // ── Retirer un article (dans le tiroir) ──
      const rem = e.target.closest("[data-cart-remove]");
      if (rem) {
        e.preventDefault(); // sinon nav pleine page vers /cart/change → casse le preview
        const item = rem.closest("[data-cart-item]");
        if (!item) return;
        changeLine(item, 0);
      }
    });

    // Saisie manuelle dans le champ quantité (dans le tiroir)
    let qtyTimer;
    drawer.addEventListener("change", (e) => {
      const input = e.target.closest("[data-cart-qty-input]");
      if (!input) return;
      const item = input.closest("[data-cart-item]");
      if (!item) return;
      let q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      input.value = q;
      clearTimeout(qtyTimer);
      qtyTimer = setTimeout(() => changeLine(item, q), 250);
    });

    // Met à jour une ligne du panier en AJAX puis re-render le tiroir (jamais de nav pleine page)
    let lineBusy = false;
    async function changeLine(item, quantity) {
      if (lineBusy) return;
      lineBusy = true;
      const key = item.getAttribute("data-key");
      item.style.opacity = "0.45";
      item.style.pointerEvents = "none";
      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
        if (!res.ok) throw new Error("cart change failed");
        await res.json();
        await refresh();
        updateCartCountGlobal();
      } catch (err) {
        item.style.opacity = "";
        item.style.pointerEvents = "";
      } finally {
        lineBusy = false;
      }
    }

    toggles.forEach((t) => t.addEventListener("click", (e) => { e.preventDefault(); open(); }));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) close();
    });

    // Recharge le contenu du tiroir depuis le serveur (Section Rendering API)
    async function refresh() {
      try {
        const res = await fetch("/?sections=cart-drawer", { headers: { Accept: "application/json" } });
        const data = await res.json();
        const tmp = document.createElement("div");
        tmp.innerHTML = data["cart-drawer"] || "";
        // On met à jour SEULEMENT le contenu du panneau : l'élément .cart-drawer__panel
        // reste le même → sa transition de glissement/fondu n'est pas cassée.
        const freshPanel = tmp.querySelector(".cart-drawer__panel");
        const panel = drawer.querySelector(".cart-drawer__panel");
        if (freshPanel && panel) {
          panel.innerHTML = freshPanel.innerHTML;
        } else {
          const fresh = tmp.querySelector("[data-cart-drawer]");
          if (fresh) drawer.innerHTML = fresh.innerHTML;
        }
        loadCartRecommendations();
      } catch (err) { /* silencieux */ }
    }

    window.DAD.cart = window.DAD.cart || {};
    window.DAD.cart.openDrawer = open;
    window.DAD.cart.closeDrawer = close;
    window.DAD.cart.refreshDrawer = refresh;
  }

  /* Compteur panier (header) */
  function updateCartCountGlobal() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll("[data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
          el.classList.toggle("is-empty", cart.item_count === 0);
        });
      })
      .catch(() => {});
  }

  /* Animation "+1" flottante — visible partout, même en scrollant */
  function pulseCartIcon() {
    // 1. Crée l'overlay flottant au centre-droite de l'écran
    const floater = document.createElement("div");
    floater.setAttribute("data-cart-floater", "");
    floater.style.cssText = [
      "position:fixed",
      "top:50%",
      "right:32px",
      "transform:translateY(-50%) scale(0.3)",
      "opacity:0",
      "z-index:9999",
      "pointer-events:none",
      "display:flex",
      "flex-direction:column",
      "align-items:center",
      "gap:4px",
      "transition:transform .4s cubic-bezier(.34,1.56,.64,1),opacity .3s ease",
    ].join(";");

    // Icône cart (SVG bag) — même style que le header
    floater.innerHTML = `
      <div style="position:relative;display:flex;align-items:center;justify-content:center;width:52px;height:52px;border-radius:50%;background:rgba(141,35,214,0.12);backdrop-filter:blur(6px)">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#8D23D6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0"></path>
        </svg>
        <span style="position:absolute;top:-6px;right:-6px;background:#8D23D6;color:#fff;font-size:13px;font-weight:800;min-width:22px;height:22px;border-radius:999px;display:flex;align-items:center;justify-content:center;padding:0 5px;box-shadow:0 2px 8px rgba(141,35,214,0.4)">+1</span>
      </div>
      <span style="font-size:11px;font-weight:600;color:#8D23D6;letter-spacing:.5px;text-transform:uppercase">Ajouté</span>
    `;

    document.body.appendChild(floater);

    // 2. Apparition — pop avec bounce
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        floater.style.opacity = "1";
        floater.style.transform = "translateY(-50%) scale(1)";
      });
    });

    // 3. Bounce sur l'icône du header en parallèle
    const headerCart = document.querySelector("[data-cart-toggle]") || document.querySelector("[data-cart-count]");
    if (headerCart) {
      headerCart.style.transition = "transform .35s cubic-bezier(.34,1.56,.64,1)";
      headerCart.style.transform = "scale(1.3)";
      setTimeout(() => { headerCart.style.transform = "scale(1)"; }, 350);
    }

    // 4. Après 1.2s, vole vers le header puis disparaît
    setTimeout(() => {
      const target = document.querySelector("[data-cart-toggle]");
      if (target) {
        const targetRect = target.getBoundingClientRect();
        const startX = window.innerWidth - 32 - 26;
        const startY = window.innerHeight / 2 - 26;
        const dx = targetRect.left + targetRect.width / 2 - startX;
        const dy = targetRect.top + targetRect.height / 2 - startY;

        floater.style.transition = "transform .5s cubic-bezier(.5,0,.75,0),opacity .5s ease";
        floater.style.transform = `translate(${dx}px,calc(-50% + ${dy}px)) scale(0.3)`;
        floater.style.opacity = "0";
      } else {
        floater.style.opacity = "0";
        floater.style.transform = "translateY(-50%) scale(0.5)";
      }
      setTimeout(() => floater.remove(), 500);
    }, 1200);
  }

  /* Intercepte TOUS les "Ajouter au panier" → AJAX → ouvre le tiroir (jamais vers /checkout) */
  function initAddToCart() {
    document.querySelectorAll(".product-form, [data-quick-add-form]").forEach((form) => {
      if (form.dataset.ajaxBound) return;
      form.dataset.ajaxBound = "1";
      form.addEventListener("submit", async (e) => {
        if (!window.fetch) return; // fallback : laisse le POST natif se faire
        e.preventDefault();
        const btn = form.querySelector("[type=submit]") || form.querySelector("button");
        const labelEl = form.querySelector("[data-add-to-cart-label]");
        const original = labelEl ? labelEl.textContent : (btn ? btn.innerHTML : "");
        if (btn) btn.disabled = true;
        if (labelEl) { labelEl.textContent = "Ajout…"; } else if (btn) { btn.innerHTML = "Ajout…"; }
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
            body: new URLSearchParams(new FormData(form)).toString(),
          });
          if (!res.ok) throw new Error("add failed");
          updateCartCountGlobal();
          if (window.DAD && window.DAD.cart) {
            if (window.DAD.cart.refreshDrawer) await window.DAD.cart.refreshDrawer();
          }
          // Animation "+1" sur l'icône du panier au lieu d'ouvrir le drawer
          pulseCartIcon();
          if (labelEl) { labelEl.textContent = "Ajouté ✓"; } else if (btn) { btn.innerHTML = "Ajouté ✓"; }
          setTimeout(() => {
            if (labelEl) { labelEl.textContent = original; } else if (btn) { btn.innerHTML = original; }
            if (btn) btn.disabled = false;
          }, 1400);
        } catch (err) {
          // Dernier recours seulement si l'AJAX échoue
          if (btn) btn.disabled = false;
          if (labelEl) { labelEl.textContent = original; } else if (btn) { btn.innerHTML = original; }
          window.location.href = "/cart";
        }
      });
    });

    // "Acheter maintenant" → ajoute + va DIRECT au checkout (n'ouvre pas le tiroir)
    document.querySelectorAll("[data-buy-now]").forEach((btn) => {
      if (btn.dataset.buyBound) return;
      btn.dataset.buyBound = "1";
      btn.addEventListener("click", async () => {
        const form = btn.closest(".product-form");
        if (!form || !window.fetch) { window.location.href = "/checkout"; return; }
        btn.disabled = true;
        const orig = btn.innerHTML;
        btn.textContent = "Un instant…";
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
            body: new URLSearchParams(new FormData(form)).toString(),
          });
          if (!res.ok) throw new Error("add failed");
          window.location.href = "/checkout";
        } catch (err) {
          btn.disabled = false;
          btn.innerHTML = orig;
        }
      });
    });
  }

  /* "Tu pourrais aussi aimer" dans le tiroir (recommandations basées sur le 1er produit du panier) */
  async function loadCartRecommendations() {
    const holder = document.querySelector("[data-cart-recommend]");
    if (!holder) return;
    const pid = holder.getAttribute("data-first-product");
    if (!pid) { holder.hidden = true; return; }
    try {
      const res = await fetch("/recommendations/products?section_id=cart-recommendations&product_id=" + pid + "&limit=3&intent=related", { headers: { Accept: "text/html" } });
      const html = await res.text();
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      const wrap = tmp.querySelector('[id^="shopify-section"]') || tmp;
      if (/cart-rec/.test(wrap.innerHTML)) {
        holder.innerHTML = wrap.innerHTML;
        holder.hidden = false;
        initAddToCart(); // lie les "+" injectés (quick-add)
      } else {
        holder.hidden = true;
      }
    } catch (err) { holder.hidden = true; }
  }

  /* ============================================================
     SEARCH client-side facets
     ============================================================ */
  function initSearch() {
    const searchSection = document.querySelector("[data-search-section]");
    if (!searchSection) return;
    const grid = searchSection.querySelector("[data-search-grid]");
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll("[data-search-item]"));
    const typeRadios = Array.from(searchSection.querySelectorAll("[data-search-type]"));
    const vendorChecks = Array.from(searchSection.querySelectorAll("[data-search-vendor]"));
    const emptyMsg = searchSection.querySelector("[data-search-empty]");
    const clearBtn = searchSection.querySelector("[data-search-clear]");

    function apply() {
      const typeRadio = typeRadios.find((r) => r.checked);
      const typeVal = typeRadio ? typeRadio.value : "all";
      const vendors = vendorChecks.filter((c) => c.checked).map((c) => c.value);

      let visible = 0;
      items.forEach((item) => {
        const itemType = item.getAttribute("data-type");
        const itemVendor = item.getAttribute("data-vendor") || "";
        let show = true;
        if (typeVal !== "all" && itemType !== typeVal) show = false;
        if (vendors.length > 0 && !vendors.includes(itemVendor)) {
          if (itemType === "product") show = false;
        }
        item.style.display = show ? "" : "none";
        if (show) visible++;
      });
      if (emptyMsg) emptyMsg.hidden = visible !== 0;
    }

    typeRadios.forEach((r) => r.addEventListener("change", apply));
    vendorChecks.forEach((c) => c.addEventListener("change", apply));
    if (clearBtn) {
      clearBtn.addEventListener("click", () => {
        typeRadios.forEach((r, i) => { r.checked = i === 0; });
        vendorChecks.forEach((c) => { c.checked = false; });
        apply();
      });
    }
  }

  /* ============================================================
     RECHERCHE PRÉDICTIVE (overlay header — native Shopify)
     Utilise /search/suggest?section_id=predictive-search :
     reflète le catalogue + l'app Search & Discovery en direct.
     ============================================================ */
  function initPredictiveSearch() {
    const root = document.querySelector("[data-predictive-search]");
    if (!root) return;
    const input = root.querySelector("[data-predictive-input]");
    const results = root.querySelector("[data-predictive-results]");
    if (!input || !results) return;
    const openers = document.querySelectorAll("[data-search-open]");

    // Sortir l'overlay du <header> (qui est sticky + z-index = contexte d'empilement)
    // sinon la barre promo passe PAR-DESSUS la recherche. Le remettre sur <body>
    // le place à la racine -> il couvre tout proprement.
    if (root.parentElement !== document.body) document.body.appendChild(root);

    function open() {
      root.removeAttribute("hidden");
      root.setAttribute("aria-hidden", "false");
      document.body.classList.add("search-open");
      setTimeout(() => input.focus(), 60);
    }
    function close() {
      root.setAttribute("hidden", "");
      root.setAttribute("aria-hidden", "true");
      document.body.classList.remove("search-open");
    }

    openers.forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); open(); }));
    root.addEventListener("click", (e) => {
      if (e.target.closest("[data-search-close]")) { e.preventDefault(); close(); }
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !root.hasAttribute("hidden")) close();
    });

    let timer, lastQ = "", ctrl;
    input.addEventListener("input", () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        results.innerHTML = "";
        results.classList.remove("is-active");
        lastQ = "";
        return;
      }
      timer = setTimeout(() => run(q), 200);
    });

    async function run(q) {
      if (q === lastQ) return;
      lastQ = q;
      results.classList.add("is-loading");
      if (ctrl) ctrl.abort();
      ctrl = (typeof AbortController !== "undefined") ? new AbortController() : null;
      try {
        const url =
          "/search/suggest?q=" + encodeURIComponent(q) +
          "&section_id=predictive-search" +
          "&resources[type]=product,collection,query" +
          "&resources[limit]=6" +
          "&resources[options][unavailable_products]=last" +
          "&resources[options][fields]=title,product_type,variants.title,vendor,tag,body";
        const res = await fetch(url, {
          headers: { Accept: "text/html" },
          signal: ctrl ? ctrl.signal : undefined,
        });
        const html = await res.text();
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        const section = tmp.querySelector(".shopify-section") || tmp;
        results.innerHTML = section.innerHTML;
        results.classList.add("is-active");
      } catch (err) {
        if (err && err.name === "AbortError") return;
        // silencieux : l'utilisateur peut toujours soumettre vers /search
      } finally {
        results.classList.remove("is-loading");
      }
    }
  }

  /* ============================================================
     BUNDLE BUILDER
     ============================================================ */
  function initBundles() {
    const bundles = document.querySelectorAll("[data-bundle-builder]");
    bundles.forEach((bundle) => {
      const discount = parseInt(bundle.getAttribute("data-discount"), 10) || 0;
      const form = bundle.querySelector("[data-bundle-form]");
      const steps = Array.from(bundle.querySelectorAll("[data-bundle-step]"));
      const subtotalEl = bundle.querySelector("[data-bundle-subtotal]");
      const totalEl = bundle.querySelector("[data-bundle-total]");
      const submitBtn = bundle.querySelector("[data-bundle-submit]");
      const noteEl = bundle.querySelector("[data-bundle-note]");

      function recompute() {
        let allSelected = true;
        let subtotal = 0;
        steps.forEach((step) => {
          const checked = step.querySelector('input[type="radio"]:checked');
          const status = step.querySelector("[data-bundle-step-status]");
          if (checked) {
            step.classList.add("is-complete");
            if (status) status.textContent = "Choisi";
            subtotal += parseInt(checked.getAttribute("data-price"), 10) || 0;
          } else {
            step.classList.remove("is-complete");
            if (status) status.textContent = "À choisir";
            allSelected = false;
          }
        });

        if (subtotalEl) subtotalEl.textContent = subtotal > 0 ? formatMoneyCents(subtotal) : "—";
        const total = Math.max(0, subtotal - (allSelected ? discount : 0));
        if (totalEl) totalEl.textContent = subtotal > 0 ? formatMoneyCents(total) : "—";

        if (submitBtn) submitBtn.disabled = !allSelected;
        if (noteEl) {
          if (allSelected) {
            noteEl.innerHTML = "Bundle prêt — économies appliquées au panier via code automatique.";
          } else {
            const missing = steps.length - steps.filter((s) => s.querySelector('input[type="radio"]:checked')).length;
            noteEl.textContent = "Encore " + missing + " étape" + (missing > 1 ? "s" : "") + " à choisir.";
          }
        }
      }

      bundle.addEventListener("change", (e) => {
        if (e.target.matches('input[data-bundle-variant]')) recompute();
      });

      if (form) {
        form.addEventListener("submit", (e) => {
          // Build the items[] payload manually so Shopify adds every selected variant.
          const selected = steps.map((s) => s.querySelector('input[type="radio"]:checked')).filter(Boolean);
          if (selected.length !== steps.length) {
            e.preventDefault();
            return;
          }
          // Replace single id input with multiple items[][id]
          // Remove default radio names so they don't post
          selected.forEach((input, i) => {
            const idField = document.createElement("input");
            idField.type = "hidden";
            idField.name = "items[" + i + "][id]";
            idField.value = input.value;
            form.appendChild(idField);
            const qtyField = document.createElement("input");
            qtyField.type = "hidden";
            qtyField.name = "items[" + i + "][quantity]";
            qtyField.value = "1";
            form.appendChild(qtyField);
            input.removeAttribute("name");
          });
        });
      }

      recompute();
    });
  }

  /* ============================================================
     BACK IN STOCK
     ============================================================ */
  function initBackInStock() {
    const widgets = document.querySelectorAll("[data-back-in-stock]");
    widgets.forEach((widget) => {
      const form = widget.querySelector("[data-back-in-stock-form]");
      if (!form) return;
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const email = form.querySelector('input[type="email"]');
        const handle = form.getAttribute("data-product-handle");
        if (!email || !email.value) return;

        // Persist to cart attributes via Shopify Ajax API (no auth needed).
        const attrs = {};
        attrs["back_in_stock_" + handle] = email.value;
        attrs["back_in_stock_product_id"] = form.getAttribute("data-product-id") || "";
        attrs["back_in_stock_product_handle"] = handle || "";

        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ attributes: attrs })
        })
          .then(() => {
            // Hook for Appikon/Klaviyo: emit a custom event
            const evt = new CustomEvent("dad:back-in-stock", {
              detail: { email: email.value, handle: handle }
            });
            document.dispatchEvent(evt);
            widget.innerHTML = '<p class="back-in-stock__intro"><strong>Inscrit!</strong> On t’écrit dès que <em>' + (handle || 'le produit') + '</em> revient.</p>';
          })
          .catch(() => {
            widget.querySelector(".back-in-stock__legal").textContent = "Petit pépin — réessaie ou appelle Daniel au 1 819 588 1402.";
          });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.DAD.product.init = init;
})();

